// extracted by mini-css-extract-plugin
export default {"videoButtonsContainer":"wFXqNpQKcWiTuk70NAZz"};